module.exports = __webpack_public_path__ + "img/p7.2039de47.png";